export enum ChangePasswordFailureReason {
  USED_RECENTLY = 1,
  CURRENT_PASSWORD_IS_WRONG,
  OTHER,
}
